import { render, staticRenderFns } from "./projectData.vue?vue&type=template&id=7dab3ad5&scoped=true"
import script from "./projectData.vue?vue&type=script&lang=js"
export * from "./projectData.vue?vue&type=script&lang=js"
import style0 from "./projectData.vue?vue&type=style&index=0&id=7dab3ad5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dab3ad5",
  null
  
)

export default component.exports